import { Project, Stats } from "../types";

export const calculateCategories = (projects: Project[]): string[] => {
  const cats = new Set<string>();
  projects.forEach((project) => {
    project.category.split(",").forEach((cat) => cats.add(cat.trim()));
  });
  return Array.from(cats).sort();
};

export const calculateStats = (
  projects: Project[],
  categories: string[]
): Stats => {
  const totalProjects = projects.length;
  const nativeProjects = projects.filter((p) => p.hlNative === "Yes").length;
  const liveProjects = projects.filter((p) => p.points !== "Not Live").length;
  const pointsProjects = projects.filter((p) => p.points === "Yes").length;

  return {
    totalProjects,
    nativeProjects,
    liveProjects,
    pointsProjects,
    categories: categories.length,
  };
};
